import React from "react";
import EventNCelebrations from "../components/Events/EventsNCelebrations";
import NavbarShared from "../components/ui/NavbarShared/NavbarShared";
function Events() {
  return (
    <>
      <NavbarShared/>
      <EventNCelebrations/>
    </>
  );
}

export default Events;
